import {
    createBuildingBlocksFromTemplate,
    subtitleGenerator,
    titleGenerator,
    stepTextContentGenerator,
    primaryButtonGenerator,
    secondaryButtonGenerator,
} from '../utils/ai-template-utils';
import { AI_LAYOUT_TEXT } from '../utils/constants';
import { BuildingBlockLayouts } from '@pendo/services/BuildingBlocks';
import { v4 as uuid } from 'uuid';

const { PrebuiltLayouts } = BuildingBlockLayouts;

export const LIGHTBOX_STEP_TEMPLATE = {
    ARTIFACT_KEYS_TO_GENERATORS: {
        subtitle: subtitleGenerator,
        title: titleGenerator,
        stepTextContent: stepTextContentGenerator,
        buttons: {
            secondaryButton: secondaryButtonGenerator,
            primaryButton: primaryButtonGenerator,
        },
    },
};

export function createFirstArtifactStep () {
    return {
        primaryButton: AI_LAYOUT_TEXT.PRIMARY_CTA,
        secondaryButton: AI_LAYOUT_TEXT.SECONDARY_CTA,
        stepTextContent: AI_LAYOUT_TEXT.BODY,
        subtitle: AI_LAYOUT_TEXT.SUBTITLE,
        title: AI_LAYOUT_TEXT.TITLE,
    };
}

export function createLightboxStepTemplate ({ theme, width, stepArtifact = {}, stepBlocks, generators }) {
    const buildingBlocks = stepBlocks || PrebuiltLayouts.LightBoxLayouts.createLightboxBlank(uuid(), theme);
    const artifactKeysToGenerators = generators || LIGHTBOX_STEP_TEMPLATE.ARTIFACT_KEYS_TO_GENERATORS;

    return createBuildingBlocksFromTemplate({
        theme,
        width,
        isEmbeddedGuide: false,
        buildingBlocks,
        stepArtifact,
        artifactKeysToGenerators,
    });
}
